import React, { Fragment, useEffect, useRef, useState } from 'react';

import { useForm, Controller } from "react-hook-form";
import { Row, Col, Card, CardBody, Button, Label, Input, InputGroup } from "reactstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormText } from 'react-bootstrap';
import { getDarkThemeColor, getServerDomainURL, renderSelectableList } from './Appcommon';
import TooltipItem from './ToolTip';
import Loading from './Loading';
import Select from "react-select";
import Switch from "react-switch";

const Form = (props) => {
    const { 
        pname, fields, submitAction, 
        formData: initialFormData, account_id,lastSyncTime,
        syncStatus,submitBeforebtn ,handleAgentChange, 
        onAddMoreVariants, removeVariant,selectAgentList, 
        currentAgents, onClickGetDetailsByApi , getAgent ,
        syncAllAgent , syncAllKB ,selectKBList ,
        getKB,currentKB,removeKnowledgeVariant,
        handleKnowledgeChange,handelRadioBtnChangeCommon,
        hideSyncAllKB,hideSyncAllAgent,hide } = props;
    const { register, handleSubmit: handleActionFormSubmit, control, formState: { errors }, setError,clearErrors } = useForm();
    const [formData, setFormData] = useState(initialFormData || {});
    const [isCopied, setTextCopied] = useState(false);
    const [localError, setLocalError] = useState([]);
    const baseUrl = getServerDomainURL();
    let Url = "events/vmhooks.php?accountid=" + account_id;
    const webhookUrl = baseUrl + "/" + Url;
    const [showApi,setShowApi] = useState(false);
    const [showPub,setShowPub] = useState(false);
    useEffect(() => {
        setFormData(initialFormData || {});
    }, [initialFormData]);


    /*
        const numbers = [1, 2, 3, 4];
        reduce() is a method in JavaScript used to "reduce" an array into a single value, 
        typically an object, array, or even a number. 
        It applies a function to each item in the array and accumulates a result, which is passed on to the next iteration.
        // Using reduce to sum the numbers
        const sum = numbers.reduce((acc, num) => {
            return acc + num;
        }, 0);  // Initial accumulator value is 0
    */
    const onClick = async (modelName) =>{
        let errorMessage = "";
        let name = "";
        if (formData[pname+"_api_key"] === undefined || formData[pname+"_api_key"] === null || formData[pname+"_api_key"].trim() === "") {
            errorMessage = "Please provide all keys.";
            name = pname+"_api_key";
        }
        if((pname === "vapi") && formData[pname+"_pub_key"] === undefined || formData[pname+"_pub_key"] === null || formData[pname+"_pub_key"] === ""){
            errorMessage = "Please provide all keys.";
            name = pname+"_pub_key";
        }
        if(errorMessage !== ""){
            setError(name, {
                type: "manual",
                message: errorMessage,
              });
            return;              
        }
        onClickGetDetailsByApi(formData,modelName);
        clearErrors();
    }

    const handelRadioBtnChange = async (All,name) =>{ 
        handelRadioBtnChangeCommon(All,name)
    }

    const onInputChange = async (e) => {
        let name = e.target.name;
        let value = e.target.value.trim();
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
        if (name.includes('api_key')) {
            setShowApi(true);
        } else if (name.includes('pub_key')) {
            setShowPub(true);
        }

    }
    const onInputChangeSwitch = async (e, name,type = "") => {
        let tmpInputData = { ...formData };
        if (type === "Switch") {
            tmpInputData[name] = e;
        }
        setFormData(tmpInputData);
    }    
    const submitProviderCredentials = async (e, name) => {
        let response = await submitAction(name, formData);
        setLocalError(response);
    }
    const copyUrl = () => {
        setTextCopied(true);
    }

    return (
        <Fragment>
            <form id={`agency-form-${pname}`} name={'agency-' + pname} onSubmit={handleActionFormSubmit((data) => submitProviderCredentials(pname, data))}>
                <div className='field-details'>
                    <Row>
                        <span className='provider-header mb-3'>{`API Key${pname == 'vapi' ? 's' : ''}`}</span>
                        {
                            fields.map((field) => {
                                const { name, label, type } = field;
                                let fname = pname + "_" + name;
                                const isHidden =(name === 'api_key' && !showApi) || (name === 'pub_key' && !showPub);
                                const rules = {};
                                if (!isHidden) {
                                    rules.required =
                                      formData[fname] === undefined || formData[fname] === ''? 'Please provide ' + label : false;
                                      rules.validate = (value) =>
                                      !/\s/.test(value) || 'Give the key value without the space';
                                  }
                                return (
                                    <Fragment>

                                        <div>
                                            <Col md={12} className={(pname === "vapi" || pname === "bland" || pname === "retell") ? '' : "field-section mt-2"}>
                                                <InputGroup>
                                                <label className={'form-label'} htmlFor={fname}>{label}</label>
                                                <div className='pl-2'>
                                                    <TooltipItem id={name == "pub_key" ? "1" : "2"} text={`${name == "pub_key" ? "Needed for server-side integration such as call logs": "Needed for client-side integration such as web calls"}`} content={<i class="fi fi-ss-info"></i>} />
                                                </div>
                                                </InputGroup>
                                                <Controller
                                                    name={fname}
                                                    control={control}
                                                    rules={rules}
                                                    render={({ field }) => {
                                                        return (
                                                            <input
                                                                {...field}
                                                                type={(name === 'api_key' && !showApi || name==='pub_key' && !showPub) ? 'password' : type}
                                                                name={fname}
                                                                id={fname}
                                                                value={formData[fname]}
                                                                autoComplete={"off"}
                                                                onChange={(e) => {
                                                                    onInputChange(e);
                                                                    field.onChange(e);
                                                                }}
                                                                className={`form-control ${errors[fname] ? 'is-invalid' : ''}`}
                                                            />
                                                        );
                                                    }}
                                                />
                                                {errors[fname] && <em className={`error invalid-feedback`}>{errors[fname].message}</em>}
                                                <div className='mt-2'>
                                                    {localError?.['apiError'] && <em className={`error invalid-feedback`}>{localError['apiError']}</em> }
                                                </div>
                                            </Col>

                                        </div>

                                    </Fragment>
                                )
                            })
                        }
                        {
                            (pname === "vapi" || pname === "bland" || pname === "retell") && (
                                <>
                                    <div className='hide'>
                                        <Col md={12} className='provider-top'>
                                            <Label>Server URL (Messaging)</Label>
                                            <div className="d-flex align-items-center">
                                                <InputGroup>
                                                    <Input value={webhookUrl} className={`google-ads-webhook-url`} disabled={true} />
                                                    <CopyToClipboard onCopy={copyUrl} text={webhookUrl}>
                                                        <Button className='theme-bg-g'>
                                                            <FontAwesomeIcon icon={faCopy} />
                                                        </Button>
                                                    </CopyToClipboard>
                                                </InputGroup>
                                            </div>
                                            {isCopied && (
                                                <FormText color="success" className="mb-2 provider-url-btn">Text has been copied.</FormText>
                                            )}
                                            <p className='ps-1 pt-2'>Please ensure the above URL is configured to receive post-call events from voice platforms. <a href='https://help.voicemetrics.ai/en/category/ai-voice-platforms' target='_blank' className='provider-url-btn'>(Learn more)</a></p>
                                        </Col>
                                    </div>
                                    <Col md={12} className='mt-3 agency-setting-title'>
                                        <Label>Set the maximum number of concurrent calls for this account.</Label> {/* Call Concurrency Limit (for Outbound Calls) */}
                                    </Col>
                                    <Col md={12} className="mt-2 mb-3">
                                        <div className="d-flex align-items-center">
                                            <Input
                                                type="number"
                                                defaultValue={8}
                                                value={formData.concurrency_limit}
                                                onChange={onInputChange}
                                                name='concurrency_limit'
                                                max={90}
                                                className={`form-control ${errors.concurrency_limit ? 'is-invalid' : ''}`}
                                            />
                                        </div>
                                    </Col>
                                    <p className='gen-description ps-1 pt-2 hide'>Please specify the Concurrent Calls Limit for outbound calls (e.g., if the limit is 10, allocate 8 for outbound calls).</p>
                                    <Col md={12} className="mt-2">
                                        <Row md={8}>
                                            <div  className='d-flex gap-3'>
                                                <Switch 
                                                    height={20} 
                                                    width={40} 
                                                    onColor={getDarkThemeColor()} 
                                                    className=""  
                                                    onChange={(e) => onInputChangeSwitch(e,"create_contact_allowed", "Switch")}
                                                    name={"create_contact_allowed"}
                                                    checked={(formData["create_contact_allowed"] !== "" && formData["create_contact_allowed"] !== undefined && formData["create_contact_allowed"] !== null) ?  formData["create_contact_allowed"] : false}
                                                />
                                                <Label className='agency-setting-title'>Auto-capture leads from calls.</Label>
                                            </div>
                                            {/* <Col md={5}>
                                            </Col> */}
                                        </Row>
                                    </Col>
                                </>
                            )
                        }
                        {!hide && (
                            <div>
                                <div className='mt-4 mb-1'>
                                    <div className='provider-header'>
                                        Choose Agents
                                    </div>
                                    <div className="mt-3 d-flex">
                                        <Label className="me-2">
                                            <Input
                                                type="radio"
                                                name="syncSpecificagent"
                                                checked={syncAllAgent === false}
                                                onChange={() => handelRadioBtnChange(false,'agent')}
                                            />
                                            <span className="ml-2">
                                                Sync Specific AI Agents 
                                            </span>
                                        </Label>
                                        <Label className="me-2">
                                            <Input
                                                type="radio"
                                                name="syncAllagent"
                                                checked={syncAllAgent === true}
                                                disabled={hideSyncAllAgent}
                                                onChange={() => handelRadioBtnChange(true,'agent')}
                                            />
                                            <span className={`ml-2 ${hideSyncAllAgent && 'disable-radio-btn'}`}>
                                                Sync All AI Agents    
                                            </span>
                                            <span className='ms-1'>
                                                {hideSyncAllAgent && (<TooltipItem id={"agent"} text={"Cannot sync all agents because the API is already synced with another account with specific configuration."} content={<i class="fi fi-ss-info"></i>} />)}
                                            </span>
                                        </Label>
                                    </div>
                                </div>
                                {!syncAllAgent && (
                                    <Row className='mt-1'>
                                        <Loading
                                            mainContent={
                                                <div>
                                                    <Col md={6}>
                                                        {getAgent  && (
                                                            <Button className='theme-bg-g' onClick={() => onClick('agent')}>
                                                                Get Agent
                                                            </Button>
                                                        )}
                                                    </Col>
                                                    {renderSelectableList(
                                                        selectAgentList,
                                                        currentAgents,
                                                        handleAgentChange,
                                                        removeVariant,
                                                        onAddMoreVariants,
                                                        'agent'
                                                    )}
                                                    { currentAgents.length === 0 && selectAgentList.length === 0 &&  !getAgent && (
                                                        <>
                                                            <div className='invalid-feedback'>
                                                                No Agent is available
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            }
                                            showLoader={false}
                                        />
                                    </Row>
                                )}
                                {localError?.['agentError'] && <em className={`error invalid-feedback`}>{localError['agentError']}</em> }
                                {
                                    (pname === "vapi" || pname === "bland" || pname === "retell") && (
                                        <div className='mt-0 hide'>
                                            <Col md={12} className='provider-top'>
                                                <Label>Status</Label>
                                            </Col>
                                            <Col md={1} className="mt-2">
                                                <div className={`d-flex align-items-center badge ${syncStatus ? 'sub-sts-active' : 'sub-sts-pym-fail'}`}>
                                                    <div className={`d-flex align-items-center ${syncStatus ? 'ps-2' : 'ps-1'}`}>{syncStatus ? 'Active' : 'Inactive'}</div>
                                                    
                                                </div>
                                            </Col>
                                            <div className='pt-2 d-flex'>
                                                <span class="">Last sync time: {lastSyncTime}</span>
                                            </div>
                                        </div>
                                    )
                                }

                                {pname !== 'bland' &&
                                    (
                                        <div className='mt-3'>
                                            <div className='provider-header'>
                                                Choose Knowledge Base   
                                            </div>
                                            <div className="mt-4 mb-1 d-flex">
                                                <Label className="me-2">
                                                    <Input
                                                        type="radio"
                                                        name="syncSpecificknowledge"
                                                        checked={syncAllKB === false}
                                                        onChange={() => handelRadioBtnChange(false,'knowledge')}
                                                    />
                                                    <span className="ml-2">
                                                        Sync Specific knowledge base only
                                                    </span>
                                                </Label>
                                                <Label className="me-2">
                                                    <Input
                                                        type="radio"
                                                        name="syncAllknowledge"
                                                        checked={syncAllKB === true}
                                                        disabled={hideSyncAllKB}
                                                        onChange={() => handelRadioBtnChange(true,'knowledge')}
                                                    />
                                                    <span className={`ml-2 ${hideSyncAllKB && 'disable-radio-btn'}`}>
                                                        Sync all knowledge base   
                                                    </span>
                                                    <span className='ms-1'>
                                                        {hideSyncAllKB && (<TooltipItem id={"kb"} text={"Cannot sync all knowledge base because the API is already synced with another account with specific configuration."} content={<i class="fi fi-ss-info"></i>} />)}
                                                    </span>
                                                </Label>
                                            </div>
                                            {
                                                !syncAllKB &&(
                                                    <>
                                                        <Row className='mt-1'>
                                                            <Loading
                                                                mainContent={
                                                                    <div>
                                                                        <Col md={6}>
                                                                            {getKB  && (
                                                                                <Button className='theme-bg-g' onClick={() => onClick('knowledge')}>
                                                                                    Get Knowledge
                                                                                </Button>
                                                                            )}
                                                                        </Col>
                                                                        {renderSelectableList(
                                                                            selectKBList,
                                                                            currentKB,
                                                                            handleKnowledgeChange,
                                                                            removeKnowledgeVariant,
                                                                            onAddMoreVariants,
                                                                            'knowledge'
                                                                        )}
                                                                        { currentKB.length === 0 && selectKBList.length === 0 &&  !getKB && (
                                                                            <>
                                                                                <div className='invalid-feedback'>
                                                                                    No Knowledge Base is available
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                }
                                                                showLoader={false}
                                                            />
                                                        </Row>
                                                    </>
                                                )
                                            }
                                            {localError?.['kbError'] && <em className={`error invalid-feedback`}>{localError['kbError']}</em> }
                                            {pname == 'vapi' &&
                                                (
                                                    <>
                                                        <div className='kb-bg mt-2'>
                                                            <strong>Note:</strong><br/>
                                                            The knowledge base integration works only if your Vapi assistant uses simple files uploaded in the "Files" section. If it uses query tools or third-party sources like Trieve, the integration won't be compatible.
                                                        </div>
                                                    </>
                                                )
                                            }
                                        </div>
                                        
                                    )
                                }
                            </div>
                        )}
                        <div className={pname === "vapi" || pname === "bland" || pname === "retell" ? "d-flex justify-center mt-4 gap-3" : 'form-footer d-block text-end mt-3'}>
                            <Button size="lg" className='theme-bg-g'>
                                {pname === "vapi" || pname === "bland" || pname === "retell" ? <div className='d-flex'>{"Update"}<span className={'ps-1 hide'}><TooltipItem id={'1'} text={"Save will sync new data only, not old data."} content={<i class="fi fi-ss-info"></i>}/></span></div> : "Save"}
                            </Button>
                            <div className='d-flex'>
                                {(pname === "vapi" || pname === "bland" || pname === "retell") && submitBeforebtn(formData)}
                            </div>
                        </div>
                    </Row>
                </div>

            </form>
        </Fragment>
    )
}

export default Form;
